import { createContext, Fragment, useContext, useEffect, useState } from "react";
import { getLang } from "@/lib/api";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(getLang());
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const setLang = (l) => { localStorage.setItem("sm-lang", l); setLangState(l); };
  // Remount children on language change so every page refetches localized content.
  return <LangContext.Provider value={{ lang, setLang }}><Fragment key={lang}>{children}</Fragment></LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
